import axios from "axios";
import { base_url } from "../config";

export const uploadTableImage = async (file, id) => {
  const accessToken = localStorage.getItem("@user");

  try {
    const formData = new FormData();
    formData.append("media", file);
    formData.append("id", id);

    const response = await axios.post(`${base_url}/tables/media-upload?id=${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading table image:", error);
    throw error;
  }
};
